import React, { useState, useEffect, useRef } from "react";

import { StyledWrapper, StyledWinnerRow } from "./singleTier.style";
import { StyledDivider } from "../challengeLeaderboard.style";
import RewardTierIcon from "../../../icons/rewardTierIcon.component";

const SingleTier = ({ data }) => {
  const [showAll, setShowAll] = useState(false);
  const [maxHeight, setMaxHeight] = useState(400);

  const solutionRowRef = useRef(null);
  const { moneyWon, name, identifier, solutions } = data;

  const renderSolutions = solutions.map((solution, index) => {
    const { user } = solution;
    const visible = showAll || index < 5;

    return (
      <StyledWinnerRow
        visible={visible ? 1 : 0}
        key={index}
        ref={(ref) => (index === 0 ? (solutionRowRef.current = ref) : null)}
      >
        <div>
          <img src={user.winnerPic} alt={user.fullName} />
          <div>
            <h4>{user.fullName}</h4>
            {user.latestUniversity && <span>{user.latestUniversity}</span>}
          </div>
        </div>
        <div>
          {solution.viewUrl && (
            <a className="solution-preview" href={solution.viewUrl}>
              View Solution
            </a>
          )}
          {solution.certificateUrl && (
            <a className="certificate-preview" href={solution.certificateUrl}>
              View Certificate
            </a>
          )}
        </div>
      </StyledWinnerRow>
    );
  });

  useEffect(() => {
    if (solutionRowRef.current) {
      const height = solutionRowRef.current.offsetHeight;
      if (height > 0) {
        setMaxHeight(height * 5);
      }
    }
  }, []);

  useEffect(() => {
    if (!solutionRowRef.current) return;

    const height = solutionRowRef.current.offsetHeight;
    if (height <= 0) return;

    if (showAll) {
      setMaxHeight(height * solutions.length);
    } else {
      setMaxHeight(height * 5);
    }
  }, [showAll]);

  return (
    <StyledWrapper showall={showAll ? 1 : 0}>
      <div>
        <div>
          <RewardTierIcon size={35} tier={identifier} />
          <h3>{name}</h3>
        </div>
        <div>{moneyWon}</div>
      </div>
      <StyledDivider />
      <div style={{ maxHeight: `${maxHeight}px` }}>{renderSolutions}</div>
      <StyledDivider />
      {solutions.length > 5 && (
        <div>
          <button onClick={() => setShowAll((p) => !p)}>
            {showAll ? "Show Less" : "Show All"}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
            >
              <path
                d="M2.32898 6.41531L6.50714 10.0713C6.507 10.0712 6.50728 10.0715 6.50714 10.0713C6.77911 10.3093 7.22048 10.3097 7.49245 10.0717C7.49269 10.0715 7.49292 10.0713 7.49316 10.0711L11.671 6.41531C11.943 6.17732 11.943 5.79147 11.671 5.55349C11.399 5.3155 10.9581 5.3155 10.6861 5.55349L7 8.77896L3.31388 5.55349C3.04191 5.3155 2.60095 5.3155 2.32898 5.55349C2.05701 5.79147 2.05701 6.17732 2.32898 6.41531Z"
                fill="#352281"
              />
            </svg>
          </button>
        </div>
      )}
    </StyledWrapper>
  );
};

export default SingleTier;
